import {h, Component, ComponentChild} from 'preact'
import axios from 'axios'
import Header from '../../create-topic-page/Header'
import Sidebar from './Sidebar'
import Loader from '../../ui-components/Loader'
import AlertComponent from '../../ui-components/AlertComponent'
import DraftDeletedModal from '../../create-topic-page/DraftDeletedModal'
import Editor from '../../editor'
import DraftDeleteConfirmationModal from '../../create-topic-page/DraftDeleteConfirmationModal'
import DraftPublishedModal from '../../create-topic-page/DraftPublishedModal'
import {ErrorResponse, ProductUpdate, PropsProductUpdateCreator, StateProductUpdateCreator} from './Types'
import Icon from '../../assets'
import ButtonControlSelector from '../../button-control-selector'
import { getNewProductUpdateActions } from './CreateOptions'
import { getDraftProductUpdateActions } from './DraftOptions'
import PreviewModal from '../../create-topic-page/PreviewModal'
import PreviewService from "../../../services/previewService";
import { CONTENT_TYPE_PRODUCT_UPDATE } from "../../utils/contentType";
import tracker from "../../../components/tracker/publish";
import {csrfToken} from '../../utils/csrfToken'

const errorMessages = {
  titleEmpty: 'Please add a title',
  titleTooShort: 'Title must contain at least 3 characters',
  forumIdEmpty: 'Please select a category'
}

declare var global: any

class ProductUpdateCreator extends Component<PropsProductUpdateCreator, StateProductUpdateCreator> {
  private csrfToken: string = ''
  private hasFileInProgress: boolean = false
  private attachments: string[] | null = null
  private content: string | undefined
  private productUpdate: ProductUpdate | null = null

  constructor (props: PropsProductUpdateCreator) {
    super(props)
    this.state = {
      id: null,
      featuredImage: null,
      open: true, // allow replies
      sticky: false,
      tags: [],
      title: '',
      content_type: 'product_update',
      isLoading: false,
      isDraft: false,
      draftSaved: false,
      triedToPublish: false,
      hasUnsavedChanges: false,
      showDraftDeletedModal: false,
      showDeletedConfirmationModal: false,
      showDraftPublishedModal: false,
      showSchedulePublishModal: false,
      showCancelScheduleConfirmationModal: false,
      showPreviewModal:false,
      isDraftDeleted: false,
      publicLabel: '',
      previewSettingValue: false,
      errors: {
        title: ''
      },
      alert: {
        messageType: null,
        messageText: ''
      },
      scheduledDateInputValue: {
        date: null,
        hours: null,
        minutes: null,
        period: null,
        error: ''
      },
      productUpdateStatus: props.productUpdateStatus,
      allProductAreas: [],
      selectedProductAreas: [],
      isPreviewPublic: null
    }

    this.content = this.state.content

    this.csrfToken = csrfToken()
    this.hasFileInProgress = false
    this.onCloseDraftDeleteModal = this.onCloseDraftDeleteModal.bind(this)
    this.onDeleteDraft = this.onDeleteDraft.bind(this)
    this.onCloseDeleteConfirmationModal = this.onCloseDeleteConfirmationModal.bind(this)
    this.onCloseDraftPublishedModal = this.onCloseDraftPublishedModal.bind(this)
    this.onEditorLoaded = this.onEditorLoaded.bind(this)
    this.onUnload = this.onUnload.bind(this)
    this.onTitleChanged = this.onTitleChanged.bind(this)
    this.onSidebarItemChanged = this.onSidebarItemChanged.bind(this)
    this.onCloseSchedulePublishModal = this.onCloseSchedulePublishModal.bind(this)
    this.onClosePreview = this.onClosePreview.bind(this)
    this.showSomethingWentWrongMessage = this.showSomethingWentWrongMessage.bind(this)
    this.showSuccessMessage = this.showSuccessMessage.bind(this)
    this.getHeaderDropdownSelectorItems = this.getHeaderDropdownSelectorItems.bind(this)
    this.onPublishDraft = this.onPublishDraft.bind(this)
    this.onPublish = this.onPublish.bind(this)
    this.createDraft = this.createDraft.bind(this)
    this.onSaveAsDraft = this.onSaveAsDraft.bind(this)
    this.onUpdateDraft = this.onUpdateDraft.bind(this)
    this.onPublishDraftAndNew = this.onPublishDraftAndNew.bind(this)
    this.onChangePreview = this.onChangePreview.bind(this)
    this.onSubmitPreview = this.onSubmitPreview.bind(this)
  }

  async componentDidMount () {
    window.addEventListener('beforeunload', this.onUnload)
    window.addEventListener('editorLoaded', this.onEditorLoaded)

    const productAreasResponse = await axios.get(`/community/api/productAreas`)
    if (productAreasResponse.data?.result) {
      this.setState({ allProductAreas: productAreasResponse.data.result })
    }

    if (this.state.productUpdateStatus === 'draft') {
      this.setState({ tags: null })
      const draftId = this.props.id
      const res = await axios.get(`/community/api/productUpdates/${draftId}`)

      this.setState({ ...res.data, selectedProductAreas: res.data.productAreas, open: !res.data.closed, previewSettingValue: res.data.isPreviewPublic })
      this.productUpdate = { ...res.data, selectedProductAreas: res.data.productAreas, open: !res.data.closed, previewSettingValue: res.data.isPreviewPublic }
      this.content = res.data.content
    } else {
      this.setState({ content: '' })
    }
  }

  componentWillUnmount () {
    window.removeEventListener('beforeunload', this.onUnload)
    window.removeEventListener('editorLoaded', this.onEditorLoaded)
  }

  onUnload (e: BeforeUnloadEvent) {
    const { isDraftDeleted, hasUnsavedChanges, title: hasTitle } = this.state
    const quillEditor = document.querySelector('.ql-editor')

    const hasContent = quillEditor
      ? !quillEditor.classList.contains('ql-blank')
      : !!this.getEditorContent().content

    if (hasUnsavedChanges && (hasTitle || hasContent) && !isDraftDeleted) {
      e.preventDefault()
      e.returnValue = ''
    }
  }

  onEditorLoaded () {
    const wysiwygEditor = global.app.editor.currentView.wysiwygEditor

    setTimeout(() => {
      wysiwygEditor.quill.on('text-change', () => {
        this.setHasUnsavedChanges()
      })
      window.addEventListener('attachmentsUpdated', () => {
        this.setHasUnsavedChanges()
      })
    }, 0)
  }

  getEditorContent () {
    const app = global.app
    if (!global.app.editor) {
      return {
        content: this.content,
        attachments: this.attachments
      }
    }
    return {
      content: app.editor.currentView.getContent(),
      attachments: app.editorModel.get('attachments')
    }
  }

  handlePostErrors (responseError: ErrorResponse) {
    this.setState({ isLoading: false })

    if (responseError) {
      if (responseError.data && responseError.data.error === 'Product update does not exist') {
        this.redirectToOverview(responseError.data.redirect)
        return
      }

      if (responseError.data.errors && responseError.data.errors[0] === 'Product update does not exist') {
        this.setState({
          isDraftDeleted: true,
          showDeletedConfirmationModal: false,
          showDraftDeletedModal: true
        })
        return
      }

      if (responseError.status === 422 && responseError.config.method === 'delete') {
        this.setState({
          showDeletedConfirmationModal: false,
          showDraftPublishedModal: true,
          isLoading: false
        })
        return
      }

      const { errors } = responseError.data
      const errorsText = errors ? Object.values(errors).join('\n') : 'Something went wrong'

      this.setState({
        alert: {
          messageType: 'error',
          messageText: errorsText
        },
        showSchedulePublishModal: false
      })
    }
  }

  hasErrors () {
    this.validateTitle()

    return this.state.errors.title !== ''
  }

  validateTitle () {
    const title = this.state.title
    if (!title) {
      this.setError('title', errorMessages.titleEmpty)
    } else if (title.length < 3) {
      this.setError('title', errorMessages.titleTooShort)
    } else {
      this.setError('title', '')
    }
  }

  setError (key: string, value: string) {
    this.setState({
      errors: {
        ...this.state.errors,
        [key]: value
      }
    })
  }

  setScheduleError (message: string) {
    this.setState({
      scheduledDateInputValue: {
        ...this.state.scheduledDateInputValue,
        error: message
      }
    })
  }

  setHasUnsavedChanges () {
    if (!this.state.hasUnsavedChanges) {
      this.setState({ hasUnsavedChanges: true })
    }
  }

  onCloseDraftDeleteModal () {
    this.setState({ showDraftDeletedModal: false })
  }

  onCloseDeleteConfirmationModal () {
    this.setState({ showDeletedConfirmationModal: false })
  }

  onCloseDraftPublishedModal () {
    this.setState({ showDraftPublishedModal: false })
  }

  onClosePreview () {
    this.setState({ showPreviewModal: false })
  }

  onCloseSchedulePublishModal () {
    this.setState({
      showSchedulePublishModal: false
    })
  }

  onTitleChanged (value: string) {
    const { triedToPublish } = this.state
    this.setState({ title: value })

    this.setHasUnsavedChanges()

    if (triedToPublish) {
      this.validateTitle()
    }
  }

  onSidebarItemChanged (field: string, value: string | boolean | number | undefined) {
    this.setState({
      [field as any]: value
    } as Pick<StateProductUpdateCreator, keyof StateProductUpdateCreator>)

    this.setHasUnsavedChanges()
  }

  redirectToOverview (url: string) {
    this.setState({ hasUnsavedChanges: false })
    window.location.assign(`${url}?deleted&title=${this.state.title}`)
  }

  async onDeleteDraft () {
    this.setState({ isLoading: true })

    try {
      await axios.delete(`/community/api/productUpdates/${this.state.id}`, { data: { csrfToken: this.csrfToken } })

      this.setState({ isLoading: false, showDeletedConfirmationModal: false })
      window.location.assign('/moderation/overview')
    } catch (error) {
      this.setState({ isLoading: false, showDeletedConfirmationModal: false })
      const responseError = error.response
      this.handlePostErrors(responseError)
    }
  }

  showSomethingWentWrongMessage () {
    this.setState({
      isLoading: false,
      alert: { messageType: 'error', messageText: 'Something went wrong, please try again later' }
    })
  }

  showSuccessMessage(message: string) {
    this.setState({
      alert: {
        messageType: 'success',
        messageText: message
      }
    })
  }

  errorMessage(response: { title?: Array<string>, content?: Array<string> }): ComponentChild {
    if (!response.title && !response.content) {
      return null
    }
    return (
      <div>
        { response.title ? (
          <div>
            Title
            <ul>
              {
                response.title.map(error => <li> {error} </li>)
              }
            </ul>
          </div>
        ) : null }
        { response.content ? (
          <div>
            Content
            <ul>
              {
                response.content.map(error => <li> {error} </li>)
              }
            </ul>
          </div>
        ) : null }
      </div>
    )
  }

  async createDraft () {
    this.setState({
      triedToPublish: true
    })

    if (this.hasErrors()) {
      return
    }

    this.setState({ isLoading: true })

    // Not in use yet
    if (this.hasFileInProgress) {
      this.setState({
        alert: {
          messageType: 'error',
          messageText: 'Please wait for your files to be uploaded'
        }
      })

      return
    }

    this.setState({ isLoading: true })

    const createProductUpdateData = {
      title: this.state.title,
      featuredImage: this.state.featuredImage,
      tags: this.state.tags,
      content: this.content,
      sticky: false,
      closed: !this.state.open,
      productAreas: this.state.selectedProductAreas.map(selectedProductArea => selectedProductArea.id),
      publicLabel: this.state.publicLabel
    }

    try {
      const resFromCreate = await axios.post('/community/api/productUpdates/create', {...createProductUpdateData, publicLabel: createProductUpdateData.publicLabel})
      if (resFromCreate.status !== 201) {
        this.showSomethingWentWrongMessage()
        return
      }

      this.setState({ hasUnsavedChanges: false })

      return resFromCreate.headers.location.replace('/v2/productUpdates/', '')
    } catch (e) {
      if (e.response?.data?.errors) {
        let message: ComponentChild = this.errorMessage(e.response.data.errors)
        this.setState({
          isLoading: false,
          alert: { messageType: 'error', messageText:  message},
          showPreviewModal: false
        })

        if (message === null) {
          this.showSomethingWentWrongMessage()
        }
      } else {
        this.showSomethingWentWrongMessage()
      }

      this.setState({ isLoading: false })
    }
  }

  async onSaveAsDraft () {
    const productUpdateId = await this.createDraft()

    if (!productUpdateId) {
      return
    }

    window.location.assign(`/product-update/draft/${productUpdateId}`)
  }

  async onPublishDraft () {
    this.setState({ isLoading: true })
    await this.onUpdateDraft()
    await this.onPublishDraftAndNew(this.state.id as number)
    this.setState({ isLoading: false })
  }

  async onUpdateDraft () {
    if (this.hasErrors()) {
      return
    }

    const id = this.state.id

    let Title, Content, Tag, Open, FeaturedImage, ProductAreas, PublicLabel

    if (this.productUpdate === null) {
      return
    }

    this.setState({ isLoading: true })

    const savedProductUpdate: ProductUpdate = this.productUpdate

    if (this.state.title !== savedProductUpdate.title) {
      Title = axios.post(`/community/api/productUpdates/${id}/editTitle`, {
        title: this.state.title
      })
    }

    if (this.content !== savedProductUpdate.content) {
      Content = axios.post(`/community/api/productUpdates/${id}/editContent`, {
        content: this.content
      })
    }

    if (this.state.publicLabel !== savedProductUpdate.publicLabel) {
      PublicLabel = axios.post(`/community/api/productUpdates/${id}/editPublicLabel`, {
        publicLabel: this.state.publicLabel
      })
    }

    if (this.state.tags !== savedProductUpdate.tags) {
      Tag = axios.post(`/community/api/productUpdates/${id}/editTags`, {
        tags: this.state.tags
      })
    }

    if (this.state.open !== savedProductUpdate.open) {
      Open = axios.post(`/community/api/productUpdates/${id}/toggleClosed`, {
        closed: !this.state.open
      })
    }

    if (this.state.featuredImage !== savedProductUpdate.featuredImage) {
      FeaturedImage = axios.post(`/community/api/productUpdates/${id}/editFeaturedImage`, {
        featuredImage: this.state.featuredImage || ''
      })
    }

    if (this.state.selectedProductAreas !== savedProductUpdate.selectedProductAreas) {
      ProductAreas = axios.post(`/community/api/productUpdates/${id}/editProductAreas`, {
        productAreas: this.state.selectedProductAreas.map(selectedProductArea => selectedProductArea.id)
      })
    }

    try {
      await Promise.all([Title, Content, Tag, Open, FeaturedImage, ProductAreas, PublicLabel])
      this.productUpdate = {...this.productUpdate,
        ...{title: this.state.title},
        ...{content: this.content || ''},
        ...{tags: this.state.tags || []},
        ...{open: this.state.open},
        ...{featuredImage: this.state.featuredImage || ''}
      }

      this.setState({
        hasUnsavedChanges: false,
        isLoading: false
      })

    } catch {
      this.showSomethingWentWrongMessage()
    }
  }

  async onPublishDraftAndNew (productUpdateId: number) {
    this.setState({ isLoading: true })

    try {
      const resFromPublish = await axios.post(`/community/api/productUpdates/${productUpdateId}/publish`)
      if (resFromPublish.status !== 201 && resFromPublish.status !== 204) {
        this.showSomethingWentWrongMessage()
        return
      }

      this.setState({
        isLoading: false,
        hasUnsavedChanges: false
      })
      this.setState({ isLoading: false })
      window.location.assign(`/product-update/${productUpdateId}`)
    } catch {
      this.showSomethingWentWrongMessage()
    }
  }

  async onPublish () {
    const productUpdateId = await this.createDraft()
    if (!productUpdateId) {
      return
    }
    this.setState({ isLoading: true })

    await this.onPublishDraftAndNew(productUpdateId)
    this.setState({ isLoading: false })

  }

  getHeaderDropdownSelectorItems () {
    if (this.state.productUpdateStatus === 'new') {
      return getNewProductUpdateActions({ saveDraft: this.onSaveAsDraft, publish: this.onPublish })
    } else {
      return getDraftProductUpdateActions({ saveChanges: this.onUpdateDraft,
        hasUnsavedChanges: this.state.hasUnsavedChanges,
        publishDraft: this.onPublishDraft,
        deleteAction: () => this.setState({ showDeletedConfirmationModal: true })
      })
    }
  }

  onChangePreview(value: boolean) {
    this.setState({
      previewSettingValue: value
    })
  }

  onSubmitPreview() {
    const {id, previewSettingValue} = this.state

    if (!id) return

    PreviewService.setVisibility(id, CONTENT_TYPE_PRODUCT_UPDATE, previewSettingValue)
        .then(res => {
          if (res.status !== 204) {
            this.showSomethingWentWrongMessage()
            return
          }
          this.handlePreviewResponse()
          this.trackPreviewChangedEvent(previewSettingValue)
        }).catch(error => {
      this.showSomethingWentWrongMessage()
    })
  }

  handlePreviewResponse () {
    this.setState(state => ({
      isLoading: false,
      showPreviewModal: false,
      isPreviewPublic: state.previewSettingValue,
      alert: { messageType: null, messageText: '' }
    }))
  }

  trackPreviewChangedEvent (isPreviewSettingPublic: boolean) {
    tracker.trackEvent('userevent', {
      'type': 'Content Sharing Settings Changed',
      'content_type': CONTENT_TYPE_PRODUCT_UPDATE,
      'id': this.state.id,
      'title': this.state.title,
      'user_id': window.inSidedData.user.userid,
      'user_name': window.inSidedData.user.name,
      'user_role': window.inSidedData.user.role,
      'setting': isPreviewSettingPublic ? 'anonymous users' : 'control users'
    })
  }

  render (props: PropsProductUpdateCreator, state: StateProductUpdateCreator) {
    const {
      id,
      title,
      open,
      sticky,
      featuredImage,
      content,
      tags,
      isLoading,
      errors,
      alert,
      showDraftDeletedModal,
      showDeletedConfirmationModal,
      showDraftPublishedModal,
      showPreviewModal,
      lastEdit,
      createdAt,
      author,
      productUpdateStatus,
      allProductAreas,
      selectedProductAreas,
      previewSettingValue,
      isPreviewPublic,
      publicLabel
    } = state

    const {
      canEndUserAddPublicTags,
      phrases
    } = props

    const labels = [
      phrases['topic.public_label.suggestion.blog'],
      phrases['topic.public_label.suggestion.news'],
      phrases['topic.public_label.suggestion.faq'],
      phrases['topic.public_label.suggestion.tutorial'],
      phrases['topic.public_label.suggestion.interview']
    ]

    let metadata = 'New product update'
    if (productUpdateStatus === 'draft' && lastEdit && author) {
      const statusMessage = 'Draft'
      const lastEdited = lastEdit.editedAt ? `Last edited ${lastEdit.editedAt} by ${lastEdit.editor.username}` : `Created ${createdAt} by ${author.username}`
      metadata = `${statusMessage} · ${lastEdited}`
    }

    return (
      <div>
        <Header
          icon={<Icon icon='productUpdate' color='#4DABF7' />}
          titleInfo={{
            title: title,
            onTitleChanged: this.onTitleChanged,
            error: errors.title,
            metadata: metadata,
            statusCircleVariant: productUpdateStatus === 'draft' ? 'draft' : null,
            published: false
          }}
          buttons={
            <div className='topic-creator__action-buttons'>
              <ButtonControlSelector items={this.getHeaderDropdownSelectorItems()}/>
            </div>
          }
        />
        {isLoading && <Loader />}
        <div className='topic-post'>
          <AlertComponent messageType={alert.messageType} sticky >{alert.messageText}</AlertComponent>
          {
            typeof content !== 'undefined' ? (
              <Editor
                isControl
                data={content}
                attachments={this.state.attachments}
                canHavePoll={false}
                onChange={(content: string, attachments: string[], hasFileInProgress:boolean) => {
                  this.content = content
                  this.attachments = attachments
                  this.hasFileInProgress = hasFileInProgress
                  this.setHasUnsavedChanges()
                }} />
            ) : null
          }
        </div>
        <Sidebar
          topicId={id}
          featuredImage={featuredImage || ''}
          onUpdate={this.onSidebarItemChanged}
          allowReplies={open}
          sticky={sticky}
          labels={labels}
          publicLabel={publicLabel}
          tags={tags}
          onError={this.showSomethingWentWrongMessage}
          onSuccess={this.showSuccessMessage}
          canEndUserAddPublicTags={canEndUserAddPublicTags}
          allProductAreas={allProductAreas}
          selectedProductAreas={selectedProductAreas.concat([])}
          onUpdateProductAreas={(prouctAreas) => { JSON.stringify(prouctAreas) !== JSON.stringify(selectedProductAreas) ? this.setState({ selectedProductAreas: prouctAreas.concat([]) }, this.setHasUnsavedChanges) : null}}
          onShowPreviewModal={() => this.setState({ showPreviewModal: true })}
          isPreviewPublic={isPreviewPublic && isPreviewPublic}
        />
        <DraftDeletedModal enableModal={showDraftDeletedModal} onClose={this.onCloseDraftDeleteModal} />
        <DraftPublishedModal contentType='product update' enableModal={showDraftPublishedModal} onClose={this.onCloseDraftPublishedModal} />
        <DraftDeleteConfirmationModal enableModal={showDeletedConfirmationModal} onClose={this.onCloseDeleteConfirmationModal} onDelete={this.onDeleteDraft} />
        <PreviewModal
            enableModal={showPreviewModal}
            onChange={this.onChangePreview}
            onClose={this.onClosePreview}
            onSubmit={this.onSubmitPreview}
            isPublic={previewSettingValue}
        />
      </div>
    )
  }
}

export default ProductUpdateCreator
